import styled from 'styled-components';

const StatusLoader = styled.div`
  margin: auto;
  height: 100%;
`;

export default StatusLoader;
